<template>
    <div class="branch-index">
        <swiperBanner :bannerList='bannerList'></swiperBanner>
        <div class="main-content">
          <!-- 就诊指南 -->
          <div class="guide-info">
              <div class="pb20 color-blank fs24">就诊指南</div>
              <div class="pb20 pre-wrap" v-html="homeIndexData.guide"></div>
              <div class="clearfix tc">
                <div class="icon-box fl mr80" v-if="homeIndexData.wb_thumb">
                  <div class="qrCodeBox">
                    <img :src="homeIndexData.wb_thumb" :alt="branchHospitalName" class="qrCode wh80">
                    <div class="pt20">官方微博</div>
                  </div>
                </div>
                <div class="icon-box fl" v-if="homeIndexData.wx_thumb">
                  <div class="qrCodeBox">
                    <img :src="homeIndexData.wx_thumb" :alt="branchHospitalName" class="qrCode wh80">
                    <div class="pt20">官方微信</div>
                  </div>
                </div>
              </div>
              <!-- 快速预约 -->
              <div class="fast-reserve" v-if="allow_appointment">
                <el-form :inline="true" :model="formInline" :rules="rules" ref="ruleForm"  class="demo-form-inline">
                        <el-form-item prop="name">
                            <el-input v-model="formInline.name" placeholder="请输入姓名" :maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item prop="mobile">
                            <el-input v-model="formInline.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item prop="date1">
                          <el-date-picker type="date" :picker-options="effectiveTime" placeholder="请选择日期"  value-format="timestamp" v-model="formInline.date1" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                        <el-form-item prop="illness">
                            <el-select v-model="formInline.illness" placeholder="请选择病症" @change="selectIllness">
                                <el-option v-for="(item,index) in illnessList" :key="index" :label="item.symptom_name" :value="item.symptom_name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="department_id">
                            <el-select v-model="formInline.department_id" placeholder="请选择科室" @change="selectDepart">
                                <el-option v-for="item in departmentList" :key="item.id" :label="item.dep_name" :value="item.department_id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="clearfix" prop="code">
                          <el-input type="text" v-model="formInline.code" auto-complete="off" placeholder="验证码" class="fl code-input"></el-input>
                          <img :src="imgCode" alt="" title="" class="fr code-img" @click="changeCode"/>
                        </el-form-item>
                        <el-form-item style="margin-top:8px;">
                            <el-button @click="submitForm('ruleForm')" class="reserveBtn fs18 fwb">快速预约</el-button>
                        </el-form-item>
                </el-form>
              </div>
          </div>
          <!-- 科室介绍 -->
          <div class="depart-info" v-if="swiperOptionList.length>0">
            <h2 class="fs24 color-blank pb20 pt40">科室介绍</h2>
            <div class="branch-swiper-box hand-shape">
              <swiper :options="swiperOption" >
                <swiper-slide v-for="(item,index) in swiperOptionList" :key="index">
                  <h3 @click="goDepartDetail(item.id)">
                    <img alt="" class="swiper-img" :src="item.img">
                    <p class="tc txt_limit fs18 color-blank pt20">{{item.name}}</p>
                  </h3>
                </swiper-slide>
              </swiper>
              <!-- 前进后退 -->
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </div>
          </div>
          <!-- 医院动态和健康教育 -->
          <div class="hospital-dynamic clearfix" v-if="dynamicList.length>0">
            <div class="dynamic-part hospital fl mr40">
              <h2 class="dynamic-title" @click="goGroup">
                <span class="fs24 color-blank">医院动态</span>
                <span class="color-branch-blue fr hand-shape">查看全部<img src="../assets/images/branch-arrow-blue.png" alt="" class="arrow-icon"></span>
              </h2>
              <div class="dynamic-img-text clearfix hand-shape" v-for="(item,index) in dynamicList" :key="index" @click="goGroupDetail(item.id)">
                  <h3>
                    <div class="fl img-left mr20">
                      <img :src="item.img" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fl">
                      <div class="fs18 color-blank mb10 txt_limit">{{item.title}}</div>
                      <div class="describe fs14 txt_limit2">{{item.description}}</div>
                    </div>
                  </h3>
              </div>
              <!-- <div class="dynamic-title-li">
                <span class="arrow-text txt_limit">文章标题很长文章标题很长文章标题很长文章标题很长文章标题很长文章标题很长文章…</span>
                <span class="fr"><img src="../assets/images/branch-arrow-right.png" alt="" class="arrow-icon"></span>  
              </div> -->
            </div>
            <div class="dynamic-part health fl" v-if="healthList.length>0">
              <h2 class="dynamic-title" @click="goHealth">
                <span class="fs24 color-blank">健康教育</span>
                <span class="color-branch-blue fr hand-shape">查看全部<img src="../assets/images/branch-arrow-blue.png" alt="" class="arrow-icon"></span>
              </h2>
              <div class="dynamic-img-text clearfix hand-shape" v-for="(item,index) in healthList" :key="index" @click="goHealthDetail(item.id)">
                  <h3>
                    <div class="fl img-left mr20">
                      <img :src="item.img" alt="" class="img-responsive">
                    </div>
                    <div class="img-right fl">
                      <div class="fs18 color-blank mb10 txt_limit">{{item.title}}</div>
                      <div class="describe fs14 txt_limit2">{{item.description}}</div>
                    </div>
                  </h3>
              </div>
              <!-- <div class="dynamic-title-li">
                <span class="arrow-text txt_limit">文章标题很长文章标题很长文章标题很长文章标题很长文章标题很长文章标题很长文章…</span>
                <span class="fr"><img src="../assets/images/branch-arrow-right.png" alt="" class="arrow-icon"></span>  
              </div> -->
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import swiperBanner from '@/components/swiperBanner'
import seoArgs from '../utils/setSeoArgs';

export default {
    props: {

    },
    data() {
        return {
            branchHospitalName:'',
            effectiveTime: {
                disabledDate: time => {
                    const oneMonth = 2 * 24 * 3600 * 1000
                    const mintime = Date.now() + oneMonth;
                    return time.getTime() < mintime;
                }
            },
            homeIndexData:'',
            allow_appointment:false,
            short_name:this.$route.params.short_name,
            swiperOptionList:[],//科室介绍
            swiperOption: {
              slidesPerView : 4,
              spaceBetween: 70,
              offsetSlidesAfter : 2,
              nextButton: '.swiper-button-next',
              prevButton: '.swiper-button-prev',
              lazy: {
                loadPrevNext: true,
              },
            },
            bannerList:[],//banner
            imgCode:'',//预约中的验证码
            formInline:{
              name:'',
              mobile:'',
              date1:'',
              date:'',
              illness:'',
              department:'',
              code:'',
              img_id:'',
              subhospital_id:'',
              hospital_id:'',
              source:1
            },
            illnessList:[],//病症列表
            departmentList:[],//科室列表
            rules: {
              name: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ],
              mobile: [
                { required: true, message: '请输入手机号码', trigger: 'blur' },
              ],
              date1: [
                { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
              ],
              illness:[
                { required: true, message: '请选择病症', trigger: 'blur' },
              ],
              department_id:[
                { required: true, message: '请选择科室', trigger: 'blur' },
              ],
              code:[
                { required: true, message: '请输入验证码', trigger: 'blur' },
              ]
            },
            dynamicList:[],//动态列表
            healthList:[],//健康教育
        };
    },
    computed:{
        hospitalname(){
            return this.$store.getters.getGroupConfig.hospitalname;
        }  
    },
    created() {
      this.getCodeImg();
      this.getConfig();
      this.getSymptomList();
      this.getHospitalName();
    },
    mounted() {
      
    },
    watch: {
      $route(to,from){
        this.short_name=to.params.short_name;
        sessionStorage.setItem('english_short_name',this.short_name);
        this.getCodeImg();
        this.getConfig();
        this.getSymptomList();
        this.getHospitalName();
      }
    },
    methods: {
      getHospitalName(){
        this.$axios.post(this.api.index.config,{},res =>{
          this.$store.dispatch('setGroupConfig',res.data);
          this.$store.dispatch('setCopyright',res.data.copy);
          this.branchHospitalName = res.data.hospitalname;

          const indexSeoInfo = this.$cookies.get(this.api.cachePrex+'1024') || {};
          indexSeoInfo.name = res.data.hospitalname;
          seoArgs.setSeoArgs(indexSeoInfo);
        });  
      },
      selectDepart(value){
         const rule = this.departmentList.find(item => item. department_id=== value);
         this.formInline.subhospital_id=rule.sub_hospital_id;
         this.formInline.hospital_id=rule.hospital_id;
         this.formInline.department=rule.department_id;
      },
      selectIllness(value){
        var data=this.illnessList;
        var departList;
        for(var i in data){
          if(data[i].symptom_name == value){
            departList=data[i].department_list
          }
        }
        this.departmentList=departList;
      },
      getSymptomList(){
        this.$axios.post(this.api.index.symptomList,{},res =>{
          this.illnessList=res.data.result || [];
        });
      },
      getConfig(){
        this.$axios.post(this.api.index.index,{},res =>{
          this.homeIndexData=res.data;
          this.allow_appointment=res.data.allow_appointment;
          this.bannerList=res.data.banner_list;
          this.swiperOptionList=res.data.department_list;
          this.dynamicList=res.data.dynamic_list;
          this.healthList=res.data.health_education_list;
        });
      },
      submitForm(formName) {
         this.$refs[formName].validate((valid) => {
          if (valid) {
             this.formInline.date=this.formInline.date1/1000;
             this.$axios.post(this.api.index.reservation,this.formInline,res =>{
                this.$message({
                    message: res.msg,
                    type: 'success'
                });   
                this.$refs[formName].resetFields();
                this.getCodeImg();
              });
          } else {
            this.getCodeImg();
            return false;
          }
        });
      },
      changeCode: function(){
        this.getCodeImg();
      },
      getCodeImg: function(){
        this.$axios.post(this.api.index.getImgCode,{}, 
          res => {                        
              this.formInline.img_id = res.data.imgid;
              this.imgCode = res.data.imgurl;
          },err =>{                        
            this.$message({
                message: err.msg,
                type: 'error'
            });
          }
        )
      },
      goGroup(){
        this.$router.push({
            path: '/dynamic/'+this.short_name+'.html'
        })
      },
      goGroupDetail(id){
        this.$router.push({
            path: '/dynamicDetail/'+this.short_name+'/'+id+'.html'
        })
      },
      goHealth(){
        this.$router.push({
            path: '/health/'+this.short_name+'.html'
        })
      },
      goHealthDetail(id){
        this.$router.push({
            path: '/healthDetail/'+this.short_name+'/'+id+'.html'
        })
      },
      goDepartDetail(id){
        this.$router.push({
            path: '/departDetail/'+this.short_name+'/'+id+'.html'
        })
      }
    },
    components: {
      swiperBanner
    },
};
</script>

<style scoped>
.branch-index{position: relative;top:-100px;}
.guide-info{padding:20px 360px 27px 41px;position: relative;margin-bottom:20px;}
.fast-reserve{position:absolute;bottom:0;right:0;width:360px;height:420px;padding:40px 60px 52px;
box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:8px;z-index:111;background:#fff;}
.reserveBtn{width:240px;height:40px;background:#4A90E2;border-radius:5px;color:#fff;}
.code-img{width:58px;height:26px;cursor:pointer;border:1px solid #DCDFE6;border-radius:4px;margin-top:6px;}
.dynamic-part{width:580px;}
.dynamic-title{padding:40px 0 20px;line-height:33px;font-size:14px;font-weight:normal;}
.dynamic-title-li{height:60px;line-height:60px;box-shadow:0px -1px 0px 0px rgba(235,235,237,1);}
.dynamic-title-li .arrow-text{width:548px;display:inline-block;}
.dynamic-img-text{padding:20px 0;height:160px;background:rgba(255,255,255,1);box-shadow:0px -1px 0px 0px rgba(235,235,237,1);}
.dynamic-img-text .img-left{width:160px;height:120px;}
.dynamic-img-text .img-right{width:400px;}
.dynamic-img-text .img-right .describe{height:80px;line-height:20px;}
.branch-swiper-box{padding:20px 70px;position: relative;}
.branch-swiper-box .swiper-img{width:200px;height:200px;}
</style>
<style>
.fast-reserve .el-form--inline .el-form-item{margin-bottom:12px;}
.fast-reserve .el-form--inline .el-form-item,
.fast-reserve .el-form--inline .el-form-item__content,
.fast-reserve .el-form-item__content .el-select{width:240px;font-size:14px;}
.fast-reserve .el-form-item__content .code-input{width:160px;font-size:14px;}
.fast-reserve .el-form-item__content .el-input__inner{height:28px;line-height:28px;font-size:14px;}
</style>



// WEBPACK FOOTER //
// src/view/index.vue